export default "__VITE_ASSET__CxynUleR__"